module.exports = __webpack_public_path__ + "static/media/footer.94316126.png";